import React, { useState } from "react";
import { toast } from "react-toastify";
import { downloadDatabaseBackup } from "../services/backupService";
import { FiDownload } from "react-icons/fi";

const Backup = () => {
  const [loading, setLoading] = useState(false);

  const handleBackup = async () => {
    setLoading(true);
    try {
      await downloadDatabaseBackup();
      toast.success("Backup downloaded successfully.");
    } catch (err) {
      toast.error(err?.message || "Backup failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Backup</h1>
      <p className="text-gray-600">
        Download a full database backup as a SQL file.
      </p>
      <div className="bg-white rounded-lg shadow p-6 max-w-lg">
        <h2 className="text-lg font-semibold mb-2">Database backup</h2>
        <p className="text-sm text-gray-600 mb-4">
          Creates a database backup. You can restore it later using  your database tool.
        </p>
        <button
          type="button"
          onClick={handleBackup}
          disabled={loading}
          className="btn btn-primary flex items-center gap-2"
        >
          {loading ? (
            <>
              <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />
              Creating backup…
            </>
          ) : (
            <>
              <FiDownload size={18} />
              Download database backup
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Backup;
